import { BulletinBiddingsTypes, BulletinFollowupTypes } from 'store/modules/bulletins_store/types';

export const emptyBidding = () => {
  const bidding: BulletinBiddingsTypes = {
    id: 0,
    bulletin_id: 0,
    bidding_id: 0,
    orgao_id: 0,
    orgao_uasg: '',
    orgao_endereco: '',
    orgao_cidade: '',
    orgao_cidade_id: 0,
    orgao_estado: '',
    orgao_estado_id: 0,
    orgao_cep: '',
    orgao_local: '',
    orgao_exigencia: '',
    orgao_classe: '',
    edital: '',
    modalidade_id: 0,
    concorrentes_internacionais: false,
    edital_site: '',
    edital_homepage1: '',
    edital_homepage2: '',
    edital_email: '',
    edital_preco: 0,
    edital_tem: false,
    edital_status_id: 0,
    edital_datahora: '',
    edital_funcionario: '',
    email: '',
    observacao_interna: '',
    liberado: false,
    pendente: false,
    motivo_pendencia: null,
    processo: '',
    tipo_valor_estimado_id: null,
    valor_estimado: 0,
    itens: '',
    tem_acompanhamento: false,
    tipo_agrupamento_id: 0,
    datahora_prazo: '',
    datahora_abertura: null,
    datahora_retirada: null,
    datahora_visita: null,
    datahora_documento: null,
    data_validade: '',
    atividade: '',
    garantia_contrato: null,
    garantia_proposta: null,
    atividade_processamento: '',
    objeto: '',
    observacao: '',
    delete_user: 0,
    datahora_processamento: null,
    edital_alterado: null,
    edital_posterior: null,
    edital_tempo_real: null,
    tipo_orgao_id: 0,
    created_at: '',
    updated_at: '',
    created_at_controle: '',
    enviar: null,
    fonte_id: null,
    bidding_grouping: {
      id: 0,
      resumo: '',
      descricao: '',
    },
    phones: [],
    faxes: [],
    public_body: {
      id: 0,
      nome: '',
    },
    modality: {
      nome: '',
    },
    monitored_by_user: false,
    has_electronic_trading: false,
    modified: '',
    edicts: [],
    has_summary: false,
    indexed_for_ai: false,
    created: '',
    datahora_validade: '',
    favorited: false,
    favorited_by: [],
    viewed_by_user: false,
    viewed_by: [],
    managed: false,
    client_comments: [],
    highlights_json: null,
    followups: null,
    electronic_trading: {
      id: 0,
      trading_situation: '',
      trading_id: '',
      source_id: 0,
      edital: '',
      uasg: '',
      promoter: '',
    },
    status_bidding_info: [],
    has_requested_edital: false,
    contracts: [],
    managers: [],
    monitors: [],
  };

  return bidding;
};

export const emptyFollowup = () => {
  const followup: BulletinFollowupTypes = {
    id: 0,
    bulletin_id: 0,
    followup_id: 0,
    bidding_id: 0,
    orgao_id: 0,
    orgao_cidade: '',
    orgao_cidade_id: 0,
    orgao_estado: '',
    orgao_estado_id: 0,
    objeto: '',
    edital: '',
    modalidade_id: 0,
    processo: '',
    atividade: '',
    fonte_id: 0,
    data_fonte: '',
    sintese: '',
    observacao_interna: '',
    liberado: false,
    pendente: false,
    motivo_pendencia: '',
    datahora_processamento: null,
    tipo_orgao_id: 0,
    created_at: '',
    updated_at: '',
    enviar: false,
    delete_user: null,
    licitacao_fonte_id: null,
    public_body: {
      id: 0,
      nome: '',
    },
  };

  return followup;
};
